































import { Vue, Prop, Component } from 'vue-property-decorator';
import ObfuscatedEmail from '@/components/ObfuscatedEmail.vue';
import LocaleSelector from './LocaleSelector.vue';

@Component({
  components: {
    LocaleSelector,
  },
})
export default class SettingsDialog extends Vue {
  @Prop(Boolean) readonly value: boolean | undefined;
}
